import React from "react";
import "./Gallery.css";
import "lightgallery.js/dist/css/lightgallery.css";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import { Element } from "react-scroll";


function importAll(r) {
  return r.keys().map(r);
}

export default function Gallery() {
  const images = importAll(
    require.context("/", false, /\.(png|jpeg|svg)$/)
  );

  const cards = images.map((img, idx) => {
    return (
      <LightgalleryItem group={`item`} src={img}>
        <div class="gallery__item">
          <img className="gallery__item-img" src={img} alt="" />
        </div>
      </LightgalleryItem>
    );
  });

  return (
    <Element name="realizations">
      <div className="menubgc"></div>
      <div className="gallery">
        <div data-aos="fade-right" className="gallery__text">
          <h2>GALLERY</h2>
          <p className="gallery__text-paragraph">
          Real Dynamic HTML Template is a Bootstrap v4.4.1 layout. There are 4 HTML pages including about, gallery, and contact. All pages has a parallax banner image. Gallery supports multiple image categories in one page. Contact page has simple contact form and Google Maps location point.
          </p>
        </div>
        <div className="gallery__grid">
          <LightgalleryProvider>{cards}</LightgalleryProvider>
        </div>
      </div>
      
    </Element>
  );
}